import script from "./TabRoutingAddresses.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabRoutingAddresses.vue?vue&type=script&setup=true&lang=ts"

import "./TabRoutingAddresses.vue?vue&type=style&index=0&id=13454837&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13454837"]])

export default __exports__